module.exports = __webpack_public_path__ + "static/img/success.8dc0d993.png";